module.exports = __webpack_public_path__ + "media/images/panda-letter-logo-674034ce506d81dcf6a3b7eeffebec08.png";